import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthenticationGuard } from './core/guard/authentication.guard';
import { AppRouteName } from './app-routing.config';

const routes: Routes = [
  {
    path: AppRouteName.App,
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [AuthenticationGuard],
  },
  {
    path: AppRouteName.Lists,
    redirectTo: `${AppRouteName.App}/${AppRouteName.Lists}`,
    canActivate: [AuthenticationGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: AppRouteName.App,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
